import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';

import { ButtonLoader } from '../../../../../../../core';
import { ClienteCentralCompraParticipante } from '../../cliente-central-compra-participante';
import { ClienteCentralCompraParticipanteFormInsertComponent } from '../form-insert';
import { ClienteCentralCompra } from '../../../cliente-central-compra';

@Component({
    selector: 'sgt-cliente-central-compra-participante-form-insert-modal',
    templateUrl: './cliente-central-compra-participante-form-insert-modal.component.html',
    styleUrls: ['./cliente-central-compra-participante-form-insert-modal.component.less']
})
export class ClienteCentralCompraParticipanteFormInsertModalComponent implements OnInit {
    elModal: any;
    isOpen: boolean;
    @ViewChild('modal', {static: true}) modal: ElementRef;

    participante: ClienteCentralCompraParticipante;
    @ViewChild('form') form: ClienteCentralCompraParticipanteFormInsertComponent;

    @Output() afterSave = new EventEmitter<ClienteCentralCompra>();

    constructor() { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.modal?.nativeElement) as any;
        this.elModal
        .on('show.bs.modal', () => {
            this.isOpen = true;
        })
        .on('shown.bs.modal', () => {
            this.form?.insert(this.participante);
        })
        .on('hide.bs.modal', () => {
            this.isOpen = false;
        })
        .on('hidden.bs.modal', () => {
            this.clear();
        });
    }

    /** Abre modal para inserir um participante em uma central de compras */
    insert(participante: ClienteCentralCompraParticipante) {
        this.participante = participante;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Limpa as variáveis do modal */
    private clear() {
        this.participante = null;
    }

    /** Fecha o modal */
    private close() {
        this.elModal.modal('hide');
        this.clear();
    }

    cancel() {
        this.close();
    }

    /** Salva a central de compras */
    save() {
        const btn = new ButtonLoader('#btnSaveCentralCompraParticipante');
        btn.loading('Salvando');
        this.form?.save()
            .then(() => {
                btn.reset();
                this.close();
                this.afterSave.emit(this.form.centralCompras);
            })
            .catch(() => {
                btn.reset();
            });
    }
}
